import type { CommunityId, CommunitySite, GridPoint, HazardKind, PowerUpKind } from '../types';

export const COMMUNITY_NAMES: Record<CommunityId, string> = {
  henderson: 'Henderson',
  oxford: 'Oxford',
  louisburg: 'Louisburg',
  enfield: 'Enfield',
  'warren-county': 'Warren County',
  'another-community': 'Another Community',
};

export interface CommunityLocation extends GridPoint {
  id: CommunitySite;
  label: string;
  objective: string;
  message: string;
  outcome: string;
}

export const COMMUNITY_LOCATIONS: CommunityLocation[] = [
  { id: 'home', label: 'HOME', objective: 'CONNECT THE HOME', message: 'A family is now connected.', outcome: 'HOME ACCESS', x: 2, y: 10 },
  { id: 'school', label: 'SCHOOL', objective: 'CONNECT THE SCHOOL', message: 'Learning reaches more students.', outcome: 'LEARNING ACCESS', x: 5, y: 2 },
  { id: 'clinic', label: 'HEALTH CLINIC', objective: 'CONNECT THE CLINIC', message: 'Care is closer to home.', outcome: 'HEALTH ACCESS', x: 12, y: 4 },
  { id: 'business', label: 'SMALL BUSINESS', objective: 'CONNECT THE BUSINESS', message: 'Local business gets connected.', outcome: 'BUSINESS ACCESS', x: 19, y: 8 },
  { id: 'community-hub', label: 'COMMUNITY HUB', objective: 'POWER THE COMMUNITY HUB', message: 'The whole community grows stronger.', outcome: 'LOCAL OPPORTUNITY', x: 23, y: 2 },
];

export const COMMUNITY_START: GridPoint = { x: 12, y: 10 };

export const COMMUNITY_POWER_UPS: { kind: PowerUpKind; point: GridPoint }[] = [
  { kind: 'bandwidth-boost', point: { x: 7, y: 10 } },
  { kind: 'wifi-extender', point: { x: 9, y: 4 } },
  { kind: 'tech-support', point: { x: 15, y: 7 } },
  { kind: 'firewall-shield', point: { x: 21, y: 4 } },
  { kind: 'encryption', point: { x: 17, y: 2 } },
];

export const COMMUNITY_HAZARDS: { kind: HazardKind; point: GridPoint }[] = [
  { kind: 'packet-loss', point: { x: 3, y: 7 } },
  { kind: 'broken-zone', point: { x: 10, y: 2 } },
  { kind: 'spam-bot', point: { x: 15, y: 4 } },
  { kind: 'phishing-trap', point: { x: 21, y: 8 } },
  { kind: 'malware-bug', point: { x: 17, y: 10 } },
];

function horizontal(paths: Set<string>, y: number, fromX: number, toX: number): void {
  for (let x = fromX; x <= toX; x += 1) paths.add(`${x},${y}`);
}

function vertical(paths: Set<string>, x: number, fromY: number, toY: number): void {
  for (let y = fromY; y <= toY; y += 1) paths.add(`${x},${y}`);
}

export function createCommunityPaths(includeShortcut = false): Set<string> {
  const paths = new Set<string>();
  [2, 4, 7, 10].forEach((y) => horizontal(paths, y, 1, 23));
  [2, 5, 8, 12, 16, 19, 23].forEach((x) => vertical(paths, x, 2, 10));
  vertical(paths, 3, 7, 10);
  vertical(paths, 21, 4, 8);
  if (includeShortcut) vertical(paths, 14, 4, 10);
  return paths;
}

export function communityPointKey(point: GridPoint): string {
  return `${point.x},${point.y}`;
}

